// extracted by mini-css-extract-plugin
module.exports = {"agentsCounter":"BusyAgentsCounter__agentsCounter--X6","busyAgentsCounter":"BusyAgentsCounter__busyAgentsCounter--Cn"};